<template>
  <div class="bq-product-fugl">
    <SectionTitle :title="'产品简介'" noSpacing></SectionTitle>
    <p class="bq-product-desc">
      服务管理平台，是将基于服务技术、组件式开发的、独立运行的服务进行统一的接入、统一管理、统一调度，实现异构服务间集成与管理，最终实现所有运行中的服务可以有序、正常、持续的运转。
    </p>
    <div class="bq-prodesc">
      <InfoBox
        :itemObj="item"
        :col="2"
        v-for="item in prodescList"
        :key="item.advTitles"
        :classes="'prodesc'"
      ></InfoBox>
    </div>
    <div class="area">
      <div class="area-title">
        服务管理平台
      </div>
      <div class="area-content">
        <div class="content-item">
          <div class="content-item-title">
            服务存储
          </div>
          <div class="data-save"></div>
        </div>
        <div class="arrow-content">
          <div class="arrow"></div>
          <div class="arrow"></div>
          <div class="arrow"></div>
        </div>
        <div class="content-item-manage">
          <div class="manage-title">
            服务管理
          </div>
          <div class="manage-adapter-content">
            <div class="item-title">Adapter1</div>
            <div class="item-title">Adapter2</div>
            <div class="item-title">···</div>
          </div>
          <div class="manage">
            <div class="manage-content-title">
              服务管理
            </div>
            <div class="manage-content">
              <div class="manage-desc">服务注册</div>
              <div class="manage-desc">服务授权</div>
              <div class="manage-desc">服务统计</div>
              <div class="manage-desc">服务日志</div>
              <div class="manage-desc">服务预警</div>
              <div class="manage-desc">异常服务管理</div>
            </div>
          </div>
          <div class="cache-desc">缓存</div>
        </div>
        <div class="content-item">
          <div class="content-item-title">
            统一网关
          </div>
          <div class="data-net">统一网关</div>
        </div>
        <div class="arrow-text-content">
          <div class="arrow-desc-content">
            <div class="arrow-desc"></div>
            <div class="arrow-text">RESTFUL</div>
          </div>
          <div class="arrow-desc-content">
            <div class="arrow-desc"></div>
            <div class="arrow-text">WebService/Soap</div>
          </div>
          <div class="arrow-desc-content">
            <div class="arrow-desc"></div>
            <div class="arrow-text">Http</div>
          </div>
        </div>
        <div class="content-item">
          <div class="content-item-title">
            外部系统
          </div>
          <div class="out-sys">
            <div class="out-sys-item">应用A</div>
            <div class="out-sys-item">应用B</div>
            <div class="out-sys-item">···</div>
            <div class="out-sys-item">应用N</div>
          </div>
        </div>
      </div>
    </div>
    <SectionTitle :title="'产品优势'" noSpacing></SectionTitle>
    <div
      class="bq-advantage"
      v-for="(itemList, idx) in advantageList"
      :key="idx"
    >
      <InfoBox
        :itemObj="item"
        :col="2"
        v-for="item in itemList"
        :key="item.advTitles"
        :classes="'advantage'"
      ></InfoBox>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'fwgl',
  data() {
    return {
      prodescList: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1xSLlDAT2gK0jSZPcXXcKkpXa-88-88.png',
          advTitles: '一体化',
          advDesc:
            '服务管理平台是针对系统庞大、需求持续增加、需求变化较为频繁、接口数目庞大、接口调用频繁，并倾向于使用服务架构系统管理，而提供一体化的服务管理平台。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1ucPnDq61gK0jSZFlXXXDKFXa-88-84.png',
          advTitles: '基础支撑',
          advDesc:
            '服务管理平台通过集成支撑服务、行业服务、工具服务、中间件服务，对所有的服务进行统一的管理和监控，对上层应用的服务调用提供基础支撑。',
        },
      ],
      advantageList: [
        [
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1hjziDEY1gK0jSZFMXXaWcVXa-84-84.png',
            advTitles: '快捷部署',
            advDesc:
              '灵活的服务配置，对外提供统一的服务接口，快速应用用户的需求变化',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1ADnlDEY1gK0jSZFCXXcwqXXa-84-82.png',
            advTitles: '服务监测',
            advDesc: '提供服务监测功能，实现对服务可视化管理及报警',
          },
        ],
        [
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1.kYiDrr1gK0jSZFDXXb9yVXa-82-84.png',
            advTitles: '动态服务配置',
            advDesc: '以中心化、动态化的管理方式管理应用配置和服务配置',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1yYjnDq61gK0jSZFlXXXDKFXa-84-84.png',
            advTitles: '一致服务调用',
            advDesc:
              '对接入地服务进行统一管理，实现服务允许过程中地熔断、降级等调度功能。',
          },
        ],
      ],
    };
  },
  components: {
    SectionTitle,
    InfoBox,
  },
};
</script>
<style lang="less" scoped>
@import './fwgl.less';
</style>
